import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Avatar } from '@/src/elements/avatar'
import { Button } from '@/src/elements/button/default'
import { IMAGE_SIZE } from '@/src/elements/image/image.constants'
import { Stack } from '@/src/elements/navigation/Stack'
import { Typography } from '@/src/elements/text/Typography'
import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { TEST_ID } from '@/src/general/constants/testId'
import { useSafeNavigate } from '@/src/general/hooks/useSafeNavigate'
import { getAvatarUrl } from '@/src/general/utils/getAvatarUrl'
import { useRoutes } from '@/src/general/utils/routes'

import { useAvatarQuery } from '../../services/useAvatarsQuery'
import { useSettingsMutation } from '../../services/useSettingsMutation'
import { SettingsScreenWrapper } from '../components/SettingsScreenWrapper'

type TAvatarScreenProps = { id: string }

export const AvatarScreen = ({ id }: TAvatarScreenProps): ReactNode => {
  const { mutateAsync, isPending } = useSettingsMutation()
  const { data } = useAvatarQuery()
  const { data: me } = useMeQuery()
  const { safeNavigate } = useSafeNavigate()
  const { routes } = useRoutes()

  const item = data?.find((avatarItem) => `${avatarItem.id}` === id)

  const isSelectedAvatarDifferentFromCurrentOne = me?.avatar?.id !== item?.id

  return (
    <SettingsScreenWrapper testID={TEST_ID.SETTINGS.AVATAR_SCREEN}>
      <Stack.Screen options={{ title: item?.name }} />
      {item && <Avatar size="4xl" src={getAvatarUrl(item, IMAGE_SIZE.AVATAR.BIG)} className="self-center" />}
      <Typography>{item?.description}</Typography>
      {isSelectedAvatarDifferentFromCurrentOne && (
        <Button
          testID={TEST_ID.AVATAR.CHOOSE_BUTTON}
          variant="solid"
          colors="primary"
          isLoading={isPending}
          onPress={() => {
            mutateAsync({ avatarId: item?.id }).finally(() => safeNavigate(routes.settings()))
          }}
        >
          <FormattedMessage id="word.choose" />
        </Button>
      )}
    </SettingsScreenWrapper>
  )
}
